import React from 'react';
import PropTypes from 'prop-types';
import TreeNodeUtils from 'tree-node-utils';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import { onDragEndEvent, onDragStartEvent, onDragUpdateEvent } from '~/helpers';
import SidebarWidgetPortal from '~/portals/sidebar-widget-portal';
import EntityBuilderHeader from '~/components/common/entity-builder-header';
import CourseBuilderFooter from '~/components/courses/course-builder-footer';
import CourseWorkspace from '~/components/courses/course-workspace';

/**
 * Main component for our Course Builder
 *
 * @param {Object} props
 * @param {Object} props.workspace
 * @param {Object} props.data
 */
const CourseBuilder = ( { workspace, data } ) => {
	const treeConfig = new TreeNodeUtils( {
		childrenField: 'tree',
		keyField: 'type',
	} );

	/**
	 * Filter Node function to count topics
	 *
	 * @param {string} query
	 */
	const filterFindFunction = ( query ) => ( i ) => {
		const keywords = query.split( /\s+/ );
		const nodeText = i.type;
		return 0 <= keywords.findIndex( ( kw ) => nodeText.includes( kw ) );
	};

	const childTopics = treeConfig.findNodes(
		workspace.present.lessons,
		filterFindFunction( 'sfwd-topic' )
	); // get all the child topics
	const finalQuizzes = 0 === workspace.present.quizzes.length ? 0 : 1; // final quizzes count as 1 if any

	// Make sure variables in totalStepsCount exist before running parseInt.
	const workSpacePresentLessonsLength = workspace.present.lessons
		? workspace.present.lessons.length
		: 0;
	const childTopicsLength = childTopics ? childTopics.length : 0;
	const workSpacePresentSectionsLength = workspace.present.sections
		? workspace.present.sections.length
		: 0;
	const totalStepsCount = parseInt(
		workSpacePresentLessonsLength +
			childTopicsLength +
			finalQuizzes -
			workSpacePresentSectionsLength,
		10
	);

	return (
		<DragDropContext
			onDragStart={ ( result ) => {
				onDragStartEvent( result );
			} }
			onDragEnd={ ( result ) => {
				onDragEndEvent( result );
			} }
			onDragUpdate={ ( result ) => {
				onDragUpdateEvent( result );
			} }
		>
			<div className="ld__builder--app">
				<main>
					<EntityBuilderHeader
						totalEntities={ totalStepsCount }
						type={ data.labels.course }
						singular={ LearnDashData.i18n.step }
						plural={ LearnDashData.i18n.steps }
						showUndo={ 0 < workspace.past.length }
					/>

					<CourseWorkspace
						totalLessons={ workspace.present.lessons.length }
					/>

					<CourseBuilderFooter />
				</main>
			</div>

			{ /* The following components are rendered as portals, the el prop need to match the ID of the sidebar metabox */ }
			<SidebarWidgetPortal
				title="Lessons"
				content="lessons"
				type="lesson"
				el="sfwd-lessons-app"
			/>
			<SidebarWidgetPortal
				title="Topics"
				content="topics"
				type="topic"
				el="sfwd-topics-app"
			/>
			<SidebarWidgetPortal
				title="Quizzes"
				content="quizzes"
				type="quiz"
				el="sfwd-quizzes-app"
			/>
		</DragDropContext>
	);
};

/**
 * Valid props
 */
CourseBuilder.propTypes = {
	workspace: PropTypes.object,
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 */
const mapDispatchToProps = () => ( {} );

export default connect( mapStateToProps, mapDispatchToProps )( CourseBuilder );
